import styled from 'styled-components';
import { Colors, mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  display: grid;
  gap: 24px;
`;
export const Bold = styled.span `
  font-weight: 600;
`;
export const Transactions = styled.div `
  display: grid;
  width: auto;
  max-height: 145px;
  overflow-y: scroll;
  z-index: 10;

  ${mediaQueries.tablet} {
    width: 100%;
  }
`;
export const Transation = styled.div `
  border-bottom: 1px solid ${Colors.GS400};

  padding: 16px 0px;

  width: 100%;

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:first-child {
    border-top: 1px solid ${Colors.GS400};
  }
`;
export const TransactionLabel = styled.div `
  display: grid;

  ${mediaQueries.tablet} {
    gap: 24px;
    grid-template-columns: 90px 100px max-content;
  }
`;
export const Refund = styled.div `
  margin-left: 36px;
  margin-top: 4px;

  font-size: 14px;
  line-height: 1.5;
  color: ${Colors.GS600};
`;
export const LoaderContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0px;
`;
